import EntityModel from '@/common/models/entity-model';

export default class BlacklistModel extends EntityModel {
    hydrate({
        id = null,
        type = null,
        value = null,
        expirationTime = null,
        createdTime = null,
        updatedTime = null,
    } = {}) {
        this.id = id;
        this.type = type;
        this.value = value;
        this.expirationTime = expirationTime;
        this.createdTime = createdTime;
        this.updatedTime = updatedTime;
    }

    getPayload() {
        return {
            type: this.type,
            value: this.value,
            expirationTime: this.expirationTime,
        };
    }
}
